import React, { useState, useEffect } from 'react';
import { useApi } from '../../../hooks/useApi';
import logger from "../../../utils/logger";
import { fmtDateTime } from '../../../utils/ruDates';
function AdminAgencyRequests() {
  const {
    request,
    showStatus
  } = useApi();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('pending');
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [comment, setComment] = useState('');
  const [processing, setProcessing] = useState(false);
  useEffect(() => {
    loadRequests();
  }, [filter]);
  const loadRequests = async () => {
    setLoading(true);
    try {
      const params = filter ? `?status=${filter}` : '';
      const data = await request(`/api/v1/admin/agency-requests${params}`);
      setRequests(data || []);
    } catch (error) {
      logger.error('Ошибка загрузки заявок', error);
    } finally {
      setLoading(false);
    }
  };
  const handleReview = async (id, status) => {
    setProcessing(true);
    try {
      await request(`/api/v1/admin/agency-requests/${id}`, {
        method: 'PATCH',
        body: JSON.stringify({
          status,
          comment
        })
      });
      showStatus('success', status === 'approved' ? 'Заявка одобрена' : 'Заявка отклонена');
      setSelectedRequest(null);
      setComment('');
      loadRequests();
    } catch (error) {
      showStatus('error', 'Ошибка обработки');
    } finally {
      setProcessing(false);
    }
  };
  const formatDate = isoString => {
    if (!isoString) return '-';
    return fmtDateTime(isoString);
  };
  const getStatusBadge = status => {
    const styles = {
      pending: {
        bg: '#f39c12',
        text: 'Ожидает'
      },
      approved: {
        bg: '#27ae60',
        text: 'Одобрено'
      },
      rejected: {
        bg: '#e74c3c',
        text: 'Отклонено'
      }
    };
    const s = styles[status] || {
      bg: '#666',
      text: status
    };
    return <span style={{
      padding: '4px 8px',
      borderRadius: '12px',
      fontSize: '12px',
      background: s.bg,
      color: 'white'
    }}>{s.text}</span>;
  };
  return <div className="admin-page">
            <h1>Заявки на режим «Агентство»</h1>

            {/* Filters */}
            <div style={{
      display: 'flex',
      gap: '10px',
      marginBottom: '20px'
    }}>
                {['pending', 'approved', 'rejected', ''].map(f => <button key={f} onClick={() => setFilter(f)} style={{
        padding: '8px 16px',
        border: 'none',
        borderRadius: '4px',
        background: filter === f ? '#3498db' : '#e9ecef',
        color: filter === f ? 'white' : '#333',
        cursor: 'pointer'
      }}>
          
                        {f === '' ? 'Все' : f === 'pending' ? 'Ожидают' : f === 'approved' ? 'Одобрены' : 'Отклонены'}
                    </button>)}
            </div>

            <div style={{
      display: 'flex',
      gap: '20px'
    }}>
                {/* List */}
                <div style={{
        flex: 1,
        maxWidth: '50%'
      }}>
                    <div style={{
          background: 'white',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          overflow: 'hidden'
        }}>
                        {loading && <div style={{
            padding: '20px',
            textAlign: 'center'
          }}>Загрузка...</div>}
                        {!loading && requests.length === 0 && <div style={{
            padding: '20px',
            textAlign: 'center'
          }}>Нет заявок</div>}
                        {requests.map(r => <div key={r.id} onClick={() => setSelectedRequest(r)} style={{
            padding: '15px',
            borderBottom: '1px solid #e9ecef',
            cursor: 'pointer',
            background: selectedRequest?.id === r.id ? '#e3f2fd' : 'white'
          }}>
              
                                <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
                                    <strong>{r.company_name}</strong>
                                    {getStatusBadge(r.status)}
                                </div>
                                <div style={{
              fontSize: '13px',
              color: '#666',
              marginTop: '5px'
            }}>{r.user_email}</div>
                                <div style={{
              fontSize: '12px',
              color: '#999',
              marginTop: '3px'
            }}>{formatDate(r.created_at)}</div>
                            </div>)}
                    </div>
                </div>

                {/* Detail */}
                <div style={{
        flex: 1
      }}>
                    {selectedRequest ? <div style={{
          background: 'white',
          borderRadius: '8px',
          padding: '20px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
                            <h2>{selectedRequest.company_name}</h2>
                            <div style={{
            marginTop: '15px'
          }}>
                                <p><strong>Email:</strong> {selectedRequest.user_email}</p>
                                <p><strong>Контактный email:</strong> {selectedRequest.contact_email}</p>
                                {selectedRequest.contact_phone && <p><strong>Телефон:</strong> {selectedRequest.contact_phone}</p>}
                                {selectedRequest.inn && <p><strong>ИНН:</strong> {selectedRequest.inn}</p>}
                                {selectedRequest.description && <div style={{
              marginTop: '15px',
              padding: '10px',
              background: '#f8f9fa',
              borderRadius: '4px'
            }}>
                                        <strong>Описание:</strong>
                                        <p style={{
                marginTop: '5px'
              }}>{selectedRequest.description}</p>
                                    </div>}
                            </div>

                            {selectedRequest.status === 'pending' && <div style={{
            marginTop: '20px',
            borderTop: '1px solid #e9ecef',
            paddingTop: '20px'
          }}>
                                    <label style={{
              display: 'block',
              marginBottom: '10px'
            }}>Комментарий (опционально):</label>
                                    <textarea value={comment} onChange={e => setComment(e.target.value)} placeholder="Причина одобрения/отклонения..." style={{
              width: '100%',
              padding: '10px',
              borderRadius: '4px',
              border: '1px solid #ddd',
              minHeight: '80px'
            }} />
              
                                    <div style={{
              display: 'flex',
              gap: '10px',
              marginTop: '15px'
            }}>
                                        <button onClick={() => handleReview(selectedRequest.id, 'approved')} disabled={processing} style={{
                flex: 1,
                padding: '12px',
                background: '#27ae60',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}>
                  
                                            ✓ Одобрить
                                        </button>
                                        <button onClick={() => handleReview(selectedRequest.id, 'rejected')} disabled={processing} style={{
                flex: 1,
                padding: '12px',
                background: '#e74c3c',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}>
                  
                                            ✗ Отклонить
                                        </button>
                                    </div>
                                </div>}

                            {selectedRequest.status !== 'pending' && selectedRequest.admin_comment && <div style={{
            marginTop: '20px',
            padding: '15px',
            background: '#f8f9fa',
            borderRadius: '4px'
          }}>
                                    <strong>Комментарий администратора:</strong>
                                    <p style={{
              marginTop: '5px'
            }}>{selectedRequest.admin_comment}</p>
                                </div>}
                        </div> : <div style={{
          background: '#f5f5f5',
          borderRadius: '8px',
          padding: '40px',
          textAlign: 'center',
          color: '#666'
        }}>
                            Выберите заявку слева
                        </div>}
                </div>
            </div>
        </div>;
}
export default AdminAgencyRequests;
